<script lang="ts" setup>
import { ref, toRefs } from 'vue';
import Dialog from 'primevue/dialog';
import { EMIT } from '@/enum';

interface PropsInterface {
  header: string;
  acceptLabel: string;
  rejectLabel?: string;
  disableAccept?: boolean;
  showFooter?: boolean;
  contentClass?: string;
}

const props = withDefaults(defineProps<PropsInterface>(), {
  blockScroll: true,
  disableAccept: false,
  acceptLabel: 'Accept',
  rejectLabel: 'Cancel',
  showFooter: true,
  contentClass: '',
});

const { header, acceptLabel, rejectLabel, contentClass, disableAccept } = toRefs(props);

const emit = defineEmits<{
  (e: EMIT.CANCEL): void;
  (e: EMIT.ACCEPT): void;
}>();

const visible = ref(true);

const accept = () => {
  emit(EMIT.ACCEPT);
  visible.value = false;
};

const cancel = () => {
  emit(EMIT.CANCEL);
  visible.value = false;
};
</script>

<template>
  <Dialog
    v-model:visible="visible"
    :modal="true"
    :header="header"
    :content-class="contentClass"
    :draggable="false"
    class="confirm-action z-5"
    @hide="cancel"
  >
    <template #header>
      <span class="font-bold">{{ header }}</span>
    </template>

    <slot></slot>

    <template #footer>
      <div v-if="showFooter" class="flex justify-content-end">
        <AppButton :text="rejectLabel" type="secondary" @click="cancel" />
        <AppButton :text="acceptLabel" type="primary" :disabled="disableAccept" @click="accept" />
      </div>
    </template>
  </Dialog>
</template>
